module.exports = __webpack_public_path__ + "static/about_system_automatic-ae1daffc346e659d3ddd2c0f03528bc7.png";